// Constants
import { USER_API } from '../constants/configs';
import { API_REQUEST } from '../constants/general';
import { Actions } from '../redux/actions';

// Utility Functions
import API from '../utils/api';
import { dispatch } from '../utils/store';
import { handleError, handleSuccess } from '../utils/toast';
import { handleProfileScore } from './profileScore';

export const getEmploymentDetailsData = (search, pageNumber, size, toastReff) => {
  dispatch(Actions.User.SetLoading, true);
  const params = {
    ...(!!search ? { search } : {}),
    ...(!!pageNumber ? { page: pageNumber, limit: size } : {})
  };

  API(API_REQUEST.get, `${USER_API}/list-employment`, { params })
    .then((res) => {
      handleSuccess(toastReff, res);
      dispatch(Actions.User.SetLoading, false);
      dispatch(Actions.Employments.SetEmployments, res?.data?.data?.data?.employment || []);
      dispatch(Actions.Employments.SetTotalRecords, res?.data?.data?.data?.count || 0);
    })
    .catch((error) => {
      dispatch(Actions.User.SetLoading, false);
      handleError(toastReff, error);
      console.log(error);
    });
};

export const deleteEmployment = (
  id,
  search,
  pageNumber,
  size,
  toastReff,
  setDeleteEmploymentModal
) => {
  dispatch(Actions.User.SetLoading, true);
  API(API_REQUEST.delete, `${USER_API}/remove-employment?id=${id}`)
    .then((res) => {
      handleSuccess(toastReff, res);
      dispatch(Actions.User.SetLoading, false);
      setDeleteEmploymentModal(false);
      getEmploymentDetailsData(search, pageNumber, size, toastReff);
      handleProfileScore(toastReff);
    })
    .catch((error) => {
      dispatch(Actions.User.SetLoading, false);
      handleError(toastReff, error);
      console.log(error);
    });
};

export const updateEmploymentDetails = (
  selectedEmployment,
  data,
  search,
  pageNumber,
  size,
  onHide,
  toastReff
) => {
  dispatch(Actions.User.SetLoading, true);
  API(
    selectedEmployment?.ID ? API_REQUEST.put : API_REQUEST.post,
    selectedEmployment?.ID
      ? `${USER_API}/update-employment?id=${selectedEmployment?.ID}`
      : `${USER_API}/add-employment`,
    { ...data }
  )
    .then((res) => {
      handleSuccess(toastReff, res);
      getEmploymentDetailsData(search, pageNumber, size, toastReff);
      onHide();
      if (!selectedEmployment?.ID) handleProfileScore(toastReff);
    })
    .catch((error) => {
      handleError(toastReff, error);
      dispatch(Actions.User.SetLoading, false);
      console.log(error);
    });
};
export const addMultipleEmploymentDetails = async (employmentsData, handleSave, toastReff) => {
  dispatch(Actions.User.SetLoading, true);
  API(API_REQUEST.post, `${USER_API}/bulk-employments-upload`, {
    employmentDetails: employmentsData
  })
    .then((res) => {
      handleSuccess(toastReff, res);
      handleSave();
      handleProfileScore(toastReff);
      dispatch(Actions.User.SetLoading, false);
    })
    .catch((error) => {
      dispatch(Actions.User.SetLoading, false);
      handleError(toastReff, error);
      console.log(error);
    });
};
